import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

// Fallbacks only. The live name and copy come from the "profile" collection in the CMS.
export const siteConfig: SiteConfig = {
    name: 'Elena Marlow',
    description: 'Product designer and front-end developer designing and building calm, considered digital products.',
    url: getOrigin()
}

export const NAV_LINKS = [
    { label: 'Work', href: '/projects' },
    { label: 'About', href: '/#about' },
    { label: 'Contact', href: '/contact' }
] as const

// How often published pages refresh their content from the CMS, in seconds.
export const REVALIDATE_SECONDS = 30
